var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"login-social-btn",attrs:{"type":"button"}},[(_vm.image.length > 0)?_c('img',{attrs:{"src":_vm.image}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }